<template lang="pug">
v-container(fluid class="tw-px-6 tw-overflow-hidden gallery-container")
  v-row(dense align="start" justify="center" class="tw-mx-auto theme-d-header-images-container")
    v-col(cols="8" class=" ")
      v-responsive
        v-img(:src="photos[0].src.large2x" cover max-height="468" class="tw-rounded-tl-md tw-rounded-bl-md")
    v-col(cols="4")
      v-row(dense)
        v-col(cols="12")
          v-responsive
            v-img(:src="photos[1].src.large2x" aspect-ratio="1.7" class="tw-rounded-tr-md")
      v-row(dense)
        v-col(cols="12")
          div(class="tw-relative")
            v-responsive
              v-img(:src="photos[2].src.large2x" aspect-ratio="1.7" class="tw-rounded-br-md")
            div(class=" tw-absolute tw-bottom-0 tw-right-0 tw-pr-4")
              v-btn(@click="showOverlay = true")
                span(class="text-none tw-text-black tw-font-bold") See all {{ photos.length }} photos
  v-dialog(v-model="showOverlay" max-width="1200px")
    v-card(class="tw-overflow-hidden")
      v-row(no-gutters align="center" justify="space-between" class="pa-4 pt-2 pb-1")
        v-col(cols="auto")
          span(class="text-h5 tw-font-bold") Photos
        v-col(cols="auto")
          v-btn(@click="showOverlay = false" color="black" x-small icon class="pa-0 ma-0")
            v-icon mdi-close
      v-card-text(class="pt-0")
        v-carousel(height="600" class="theme-d-carousel pt-0")
          v-carousel-item(v-for="(photo, index) in photos" :key="index")
            v-img(:src="photo.src.large" contain aspect-ratio="1.7")
</template>

<script>
export default {
  name: 'PhotoGallery',
  props: {
    photos: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      showOverlay: false,
    };
  },
};
</script>

<style>
.gallery-container {
  max-width: 1200px;
  max-height: 495px;
}

.theme-d-header-images-container {
  max-width: 1200px;
}

.theme-d-carousel .v-item--active {
  background-color: transparent !important;
}
</style>
